export class User{
    ContactPersonId: number;
    Name: string;
}

